module.exports = __webpack_public_path__ + "static/media/ml-img.3527d65c.jpg";